import { useSystemConfig } from "./useSystemConfig";
import { IMAGE_URL } from "../Constant";

export const useAppBranding = () => {
  const {
    appName,
    appLogo,
    storeName,
    address,
    phone,
    email,
    whatsapp,
    currency,
    taxRate,
    maxDiscount,
    invoicePrefix,
    receiptFooter,
    language,
    timezone,
    get,
    isLoading,
  } = useSystemConfig();

  const logoUrl = `${IMAGE_URL}/${appLogo}`;

  return {
    isLoading,
    appName,
    storeName,
    logoUrl,
    logoName: appLogo,
    address,
    phone,
    email,
    whatsapp,
    currency,
    taxRate,
    maxDiscount,
    invoicePrefix,
    receiptFooter,
    language,
    timezone,
    get,
  };
};
